export function hasDraftSnapshotFieldValue(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === "string") return value.trim().length > 0;
  if (Array.isArray(value)) return value.length > 0;
  return true;
}

export function compactDraftSnapshotFields(
  fields: Record<string, unknown>
): Record<string, unknown> {
  return Object.fromEntries(
    Object.entries(fields).filter(([, value]) => hasDraftSnapshotFieldValue(value))
  );
}

export function buildFrameworkEntityDraftSnapshot(input: {
  name: string;
  ownerFields?: Record<string, unknown>;
  metadataFields?: Record<string, unknown>;
  documentJson: unknown;
}) {
  return {
    name: input.name,
    ...compactDraftSnapshotFields(input.ownerFields ?? {}),
    ...compactDraftSnapshotFields(input.metadataFields ?? {}),
    documentJson: input.documentJson,
  };
}
